import React from "react";
import jwt from "../../utils/jwt";
import "./passengerDetailsTile.scss";
import { formatTime } from "../../utils/common";
import { Fetch } from "../../utils/fetch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class PassengerDetailsTile extends React.Component {
  state = {
    isViewMoreClicked: false,
    isDialDisabled: false,
    coreServiceNames: {},
    expandedBookings: {},
  };

  componentDidMount() {
    toast.configure();
  }

  viewMoreDetails = () => {
    const { isViewMoreClicked } = this.state;
    this.setState({ isViewMoreClicked: !isViewMoreClicked });
  };

  handleDial = async (mobileNo) => {
    if (this.state.isDialDisabled) return;

    this.setState({ isDialDisabled: true });
    setTimeout(() => {
      this.setState({ isDialDisabled: false });
    }, 5000);

    const token = localStorage.getItem("idToken");
    const decodedToken = jwt.decode(token);
    const userMobileNo = decodedToken.mobileNo;

    const url = "/cabOperator/clickToCall";
    const options = {
      method: "post",
      data: {
        caller: userMobileNo,
        receiver: mobileNo,
      },
    };

    const response = await Fetch(url, options);
    if (response === "call success") {
      toast.success(
        "Call initiated successfully! You will receive a connecting call soon",
      );
    }
  };

  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  fetchCoreService = async (connectingBookingCode) => {
    const url = `/cabOperator/getServiceName/${connectingBookingCode}`;

    const options = {
      method: "get",
    };
    const response = await Fetch(url, options);
    if (response) {
      this.setState((prevState) => ({
        coreServiceNames: {
          ...prevState.coreServiceNames,
          [connectingBookingCode]: {
            connectingBookingServiceName: response.connectingBookingServiceName,
            coreLegPnr: response.coreLegPnr,
          },
        },
      }));
    } else {
      return [];
    }
  };

  toggleDetails = async (connectingBookingCode) => {
    if (!connectingBookingCode) return;

    this.setState((prev) => ({
      expandedBookings: {
        ...prev.expandedBookings,
        [connectingBookingCode]: !prev.expandedBookings[connectingBookingCode],
      },
    }));

    if (!this.state.coreServiceNames[connectingBookingCode]) {
      await this.fetchCoreService(connectingBookingCode);
    }
  };

  render() {
    const { bookingData, startTime, isTrackBusLoading, openTrackPage } =
      this.props;
    const {
      name,
      fromStation,
      toStation,
      fromStationDate,
      toStationDate,
      noOfSeats,
      mobileNo,
      connectingBookingCode,
    } = bookingData;
    const { isViewMoreClicked, coreServiceNames, expandedBookings } =
      this.state;
    return (
      <div className="passengerDetailsTile">
        <div className="detailsHeader">
          <span className="tripId">{name}</span>
        </div>
        <div className="center">
          <span className="marshalDetails">
            <span className="name">
              {noOfSeats && noOfSeats === 1
                ? `${noOfSeats} seat`
                : `${noOfSeats} seats`}
            </span>
            <div className="buttonWrapper">
              <button
                className="trackButton"
                onClick={openTrackPage}
                disabled={isTrackBusLoading}
              >
                <img
                  src="https://d1flzashw70bti.cloudfront.net/original/images/trackBus.svg"
                  alt="track"
                />
                Track
              </button>
              {startTime + 14400000 > Date.now() ? (
                <div
                  className="callWrapper"
                  onClick={() => this.handleDial(mobileNo)}
                >
                  <img
                    src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/callIcon.svg"
                    alt="call marshal"
                    className="callIcon"
                  />
                  <span className="text">Call</span>
                </div>
              ) : null}
            </div>
          </span>
        </div>
        <div className="moreDetails" onClick={() => this.viewMoreDetails()}>
          <span className="viewMoreLessToggle">
            {isViewMoreClicked ? "Less Details" : "View Details"}
          </span>
          <img
            src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/tile/purpleangleright.svg"
            alt="Details Icon"
            className={
              isViewMoreClicked ? "detailsIcon viewLess" : "detailsIcon"
            }
          />
        </div>
        {isViewMoreClicked && (
          <div className="extendedTile">
            <div className="infoGroup">
              <div className="labelAndTime">
                <span className="label">Pickup</span>
                <span className="time">
                  {formatTime(fromStationDate, "h:mm A")}
                </span>
              </div>
              <div className="address">{fromStation.name}</div>
            </div>

            <div className="arrowWrapper">
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/opd/tiles/blackarrowright.svg"
                alt="Arrow Icon"
                className="arrowIcon"
              />
            </div>

            <div className="infoGroup">
              <div className="labelAndTime">
                <span className="label">Drop</span>
                <span className="time">
                  {formatTime(toStationDate, "h:mm A")}
                </span>
              </div>
              <div className="address">{toStation.name}</div>
            </div>
            {connectingBookingCode ? (
              <div className="serviceName">
                <div
                  className="serviceViewButton"
                  onClick={() => this.toggleDetails(connectingBookingCode)}
                >
                  <span>
                    {expandedBookings[connectingBookingCode]
                      ? "Hide Details"
                      : "View Details"}
                  </span>

                  <img
                    src={
                      expandedBookings[connectingBookingCode]
                        ? "https://d1flzashw70bti.cloudfront.net/original/images/tracer/arrow.svg"
                        : "https://d1flzashw70bti.cloudfront.net/original/images/tracer/arrowView.svg"
                    }
                    alt="toggleArrow"
                  />
                </div>

                {expandedBookings[connectingBookingCode] &&
                  coreServiceNames[connectingBookingCode] && (
                    <>
                      <div className="serviceNameDetails">
                        <span>
                          {coreServiceNames[connectingBookingCode].connectingBookingServiceName}
                        </span>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/copyicon.svg"
                          alt="copy"
                          className="copyIcon"
                          onClick={() =>
                            this.copyToClipboard(
                              coreServiceNames[connectingBookingCode]
                                .connectingBookingServiceName,
                            )
                          }
                        />
                      </div>
                      <div className="serviceNameDetails">
                        <span>
                          {coreServiceNames[connectingBookingCode].coreLegPnr}
                        </span>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/copyicon.svg"
                          alt="copy"
                          className="copyIcon"
                          onClick={() =>
                            this.copyToClipboard(
                              coreServiceNames[connectingBookingCode]
                                .coreLegPnr,
                            )
                          }
                        />
                      </div>
                    </>
                  )}
              </div>
            ) : null}
          </div>
        )}
      </div>
    );
  }
}

export default PassengerDetailsTile;
